import {
    Flex,
    Stack,
    Icon,
    Heading,
    Text,
    Image,
    Box,
    AspectRatio,
    SimpleGrid,
    GridItem,
    VStack,
} from "@chakra-ui/react";
import { ImGift } from "react-icons/im";
import couple from '../../../assets/images/svg/couple.svg'
function EventIntro() {
    return (
        <SimpleGrid margin={3} columns={{ base: 2, md: 2, lg: 2 }} spacing={2} alignContent='center' justifyContent="center">

            <GridItem colSpan={{ base: 1, md: 1, lg: 1 }}>
                <VStack align="center">
                    <Text alignItems="center"
                        fontSize="xl" fontFamily="'Nanum Myeongjo', serif;">
                        We’ve said “yes,” picked a date, and maybe spent a little too much time
                        debating cake flavors—but now it’s time for the best part:
                        celebrating with all of you!

                    </Text>
                    <Text alignItems="center"
                        fontSize="xl" fontFamily="'Nanum Myeongjo', serif;">
                        This day isn’t just about the two of us—it’s about the amazing people
                        who’ve supported us, laughed with us, and stood by us along the way.

                        Your love and friendship mean the world to us, and we truly can’t wait
                        to share this joyful moment together.



                    </Text>
                    <Text alignItems="center"
                        fontSize="xl" fontFamily="'Nanum Myeongjo', serif;">
                        So whether you’re here to raise a glass, dance the night away, or share
                        in the happy tears, we’re so grateful to have you with us.

                        We’re excited to create memories that will last a lifetime!

                    </Text>
                </VStack>
            </GridItem>
            <GridItem colSpan={{ base: 1, md: 1, lg: 1 }}>
                <Box maxH="350px">
                    <Image src={couple} alt='couple' />
                </Box>
            </GridItem>
        </SimpleGrid>
    )
}

export default EventIntro;